// extracted by mini-css-extract-plugin
export default {"m":"d2e6da7f38","title":"_36660a3fe3","feedback_inner_title":"_68eda08f4c","textarea":"_82449d080e","radio":"_1da4d5dd96","text":"_71682b83dd"};